"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = require("react");
var WofSpot = (0, react_1.forwardRef)(function (_a, ref) {
    var spot = _a.spot;
    return (0, jsx_runtime_1.jsx)("div", __assign({ ref: ref, className: (0, clsx_1.default)("wof-container--body-spot", spot.highlighted && "wof-container--body-spot--active") }, { children: spot.title }));
});
WofSpot.displayName = "WofSpot";
exports.default = WofSpot;
